<script>

import Swal from 'sweetalert2'
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from '@/helpers/helper';

import { ref } from "vue";


/**
 * Dashboard Component
 */
export default {
    setup() {
      const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false)

        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen
        };
    },
    page: {
    title: "users",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Utilisateurs",
      items: [
        {
          text: "Définition",
        },
        {
          text: "Utilisateurs",
          active: true,
        },
      ],
      page: 1,
      perPage: 25,
      users: [],
      users_search: [],
      search: '',
      status: 201,
    };
  },
  methods: {
    loadList() {
      fetch(Helper.route('users'), Helper.requestOptionsJSON())
      .then(response => {
          Helper.tokenChecker(response.status)
          return response.json()
      })
      .then(data => {
        console.log(data);
        
        this.users_search = data.filter(user => user.roles.some(role => ['admin', 'agent', 'manager'].includes(role)))
        this.users = this.users_search;
        this.doesLoadingOpen = false
      })
    },
    toggleStatus(user_id) {
      Swal.fire("Méhode modifier !", user_id+"La méthode a été modifié avec succès.", "success");
      fetch(Helper.route('users/'+this.method.id), Helper.requestOptionsJSON())
      .then(response => {
          Helper.tokenChecker(response.status)
          this.status = response.status
          return response.json()
      })
      .then(data => {
        this.loading = false
        console.log(data);
        
        if (this.status >= 200 && this.status < 300) {
          this.doesEditOpen = false
          this.methods = this.methods.map(i => i.id !== this.method.id ? i : data)
          Swal.fire("Méhode modifier !", "La méthode a été modifié avec succès.", "success");
        } else {
            this.errors.name = Helper.getError(data, "method_name")
        }
      })
      .catch(error => {
        console.log(error);
        this.loading = false
      })
    },
    toManager (user_id) {
      let body = {
        "role": "manager",
        "status": "active"
      }
      fetch(Helper.route('users/'+user_id+'/status/toggle'), Helper.requestOptionsJSON("PUT", body))
      .then(response => {
          Helper.tokenChecker(response.status)
          this.status = response.status
          return response.json()
      })
      .then(data => {
        this.loading = false
        console.log(data);
        
        if (data.status == 'active') {
          Swal.fire("Agent !", "L'utilisateur est desormais un agent.", "success");
        } 
      })
      .catch(error => {
        console.log(error);
        this.loading = false
      })
    },
    toAgent (user_id) {
      let body = {
        "status": "active",
        "user": {
          "id": user_id
        }
      }
      fetch(Helper.route('agents'), Helper.requestOptionsJSON("POST", body))
      .then(response => {
          Helper.tokenChecker(response.status)
          this.status = response.status
          return response.json()
      })
      .then(data => {
        this.loading = false
        console.log(data);
        
        if (data.status == 'active') {
          Swal.fire("Agent !", "L'utilisateur est desormais un agent.", "success");
        }
      })
      .catch(error => {
        console.log(error);
        this.loading = false
      })
    },
    filter_user() {    
      this.users = this.users_search
      if (this.search != "") {
        this.users = this.users.filter(user => (
          user.lastName?.toLowerCase().includes(this.search.toLowerCase()) || 
          user.firstName?.toLowerCase().includes(this.search.toLowerCase()) || 
          user.email?.toLowerCase().includes(this.search.toLowerCase())
        )) 
      }
    },
    show(index) {
        return (index < this.page * this.perPage && (index + 1) > (this.page - 1) * this.perPage)
    },
    next() {
        if ((this.page * this.perPage) < this.users.length) {
            this.page++
        }
    },
    previous() {
        if (this.page >= 2) {
            this.page--
        }
    },
  },
  mounted() {
    this.loadList()
    this.doesLoadingOpen = false
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status !== 403">
      <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
      
    </div>

    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des Utilisateurs</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>Utilisateurs</code>.
            </p>

            <div class="row mb-4">
              <div class="col-md-3">
                <input type="search" class="form-control" v-model="search" v-on:input="filter_user()" placeholder="Rechercher une personne">
              </div>
              <div class="col-2 ms-auto">
                <select v-model="perPage" class="form-control text-center">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                </select>
              </div>

              <div class="ms-2 col-3 ps-5 hstack">
                <i class="bx bx-left-arrow-alt p-2 fs-5" type="button" @click="previous"></i>

                <small class="ms-3">
                  {{ Math.ceil(users.length / perPage) > 0 ? page : 0 }} /
									{{ Math.ceil(users.length / perPage) }}
                </small>
                
                <i class="bx bx-right-arrow-alt fs-5 p-2 ms-3" type="button" @click="next"></i>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr class="bg-light">
                    <th>#</th>
                    <th>Nom</th>
                    <th>Prénom</th>
                    <th>Sexe</th>
                    <th>Email</th>
                    <th>Rôle</th>
                    <th class="text-center">Statut</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in users" v-show="show(index)" :key="user.id">
                    <th scope="row">
                      <img :src="user?.profile" :alt="user.lastName" style="height: 35px; width: 35px" class="border rounded-circle">
                    </th>
                    <td>{{ user.lastName }}</td>
                    <td>{{ user.firstName }}</td>
                    <td>{{ user.gender == true ? "Masculin" : "Féminin" }}</td>
                    <td>{{ user.email }}</td>
                    <td>{{ user.roles.join(" & ") }}</td>
                    <td class="text-center">
                      <button class="badge badge-pill badge-soft-success border-0 py-1 w-100" v-if="user.status == 'active'">ACTIF</button>
                      <button class="badge badge-pill badge-soft-danger border-0 py-1 w-100" v-else>{{ user.status }}</button>
                    </td>

                    <td class="hstack">

                       <div class="hstack">
                        <div class="dropdown">
                          <button
                            class="btn btn-secondary dropdown-toggle rounded-circle btn-sm"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          ><i class="bx bx-dots-vertical-rounded fs-5"></i></button>
                          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <li>
                              <button class="dropdown-item" @click="toManager(user.id)">
                                To Manager
                              </button>
                            </li>
                            <li>
                              <button class="dropdown-item" @click="toAgent(user.id)">
                                To Agent
                              </button>
                            </li>
                            <li>
                              <button
                                class="dropdown-item"
                                @click="toggleStatus(user.id)"
                              >Bloquer</button>
                            </li>
                            <li>
                              <router-link class="dropdown-item" :to="'/users/' + user.id"
                                >Details</router-link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <router-link :to="'/users/' + user.id">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            
          </div>
        </div>
      </div>
    </div>

    <div v-show="status === 403">
      <h3 class="text-red-">Vous n'avez pas accès à cette page</h3>
    </div>


    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..."
      title-class="font-18" hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>


  </Layout>
</template>
